import vendor from "@/vendors/xh";
import api from "@/vendors/api";
const API = api.wxOauth;
const checkOauth = (to) => {
  if (to.currentRoute.path === "/") {
    let wxUserInfo = vendor.getWxUserInfo();
    if (!wxUserInfo) {
      document.location.href =
        API +
        "/sy-teamtop?type=wechat&scope=snsapi_userinfo&redirect_url=" +
        encodeURIComponent(window.location.href);
      return false;
    }
    console.log("wxUserInfo", wxUserInfo);
  }
};

export default checkOauth;
